module.exports = __webpack_public_path__ + "static/media/sodimac.ea29b845.svg";